"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const badge_1 = require("@andes/badge");
const classnames_1 = __importDefault(require("classnames"));
const ClockIcon_1 = __importDefault(require("../../../../assets/icons/ClockIcon"));
const PillComponent = (props) => {
    const { color, text } = props;
    const contentType = text || color === 'gray' ? 'text' : 'icon';
    const grayIconClass = (0, classnames_1.default)({
        'pending-icon andes-badge--pill-icon': color === 'gray' && !text,
    });
    const grayIcon = color === 'gray' && !text && react_1.default.createElement(ClockIcon_1.default, { color: '#737373' });
    return (react_1.default.createElement(badge_1.Pill, { ...props, className: grayIconClass, color: color, contentType: contentType }, text || grayIcon));
};
exports.default = PillComponent;
//# sourceMappingURL=index.js.map